import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import { useDeleteDocumentMutation, useMergeChecksMutation } from 'API/order/documents/DocumentApi';
import { createDownloadDocumentUrl } from 'API/order/documents/adminDocumentsAPI';
import { useGetDetailedEscrowDataQuery } from 'API/order/escrow/EscrowBaseAPI';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { IEscrowFileCompleteData } from 'types/order/escrow/IEscrowFileCompleteData';
import { PageLoading } from 'ui-toolkit';
import { PDFPreview } from 'ui-toolkit/components/PDFPreview';

export interface IPrintChecksStep {}

export const PrintChecksStep: React.FC<IPrintChecksStep> = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const [previewDoc, setPreviewDoc] = React.useState<{ id: string; version: string } | null>(null);
  const [onMergeChecks, { isLoading: isMergingChecksLoading }] = useMergeChecksMutation();
  const [onDeleteCheckDocument] = useDeleteDocumentMutation();
  const { data = {} as IEscrowFileCompleteData } = useGetDetailedEscrowDataQuery(orderId);
  const checkIds = useMemo(() => {
    return (
      data.manualCheckDisbursements
        // Sent at is the real thing to check, void is added just in case
        ?.filter((check) => !check.sentAt && !check.sentAtDate && !check.voidedAt && !check.holdback)
        ?.map((check) => check.id) ?? []
    );
  }, [data]);

  useEffect(() => {
    if (checkIds.length > 0) {
      const result = onMergeChecks({
        orderId,
        documentIds: checkIds,
        label: `All checks of ${orderId}`,
        outputCategory: 'Checks',
      });

      result.then((result) => {
        if (checkForMutationSuccess(result, 'merging checks')) {
          setPreviewDoc({
            id: result.data.standardDocumentId,
            version: result.data.id,
          });
        }
      });

      return () => result.abort();
    }
    return () => {};
  }, [checkIds, onMergeChecks, orderId]);

  const onDocumentLoad = useCallback(() => {
    if (previewDoc) {
      onDeleteCheckDocument({ documentId: previewDoc.id, versionId: previewDoc.version, orderId });
    }
  }, [previewDoc, orderId, onDeleteCheckDocument]);

  return (
    <>
      {isMergingChecksLoading && <PageLoading isLoading={true} />}
      {previewDoc && !isMergingChecksLoading && (
        <div className={'z-[-1] h-0 w-0'}>
          <PDFPreview
            printOnLoad
            previewStyle="card"
            file={createDownloadDocumentUrl(previewDoc.id, previewDoc.version)}
            onClose={() => {}}
            onDocumentLoad={onDocumentLoad}
          />
        </div>
      )}
    </>
  );
};
